import {actions as A} from '../constants/actions';

const defaultState = {
  nextStep: null,
  currentUserStepNumber: 0,
  totalSteps: 0,
  goBack: false,
  desktopCompletedStages: [],
  loading: false,
  error: false,
  errorMessage: null
};

export default (state = defaultState, {type, payload}) => {
  switch(type) {
    case A.GET_NEXT_STEP:
      return {...state, loading: true};

    case A.GET_NEXT_STEP_SUCCESS:
      return {...state, loading: false, ...payload};

    case A.GET_NEXT_STEP_FAILURE:
    case A.UPLOAD_FILE_FAILURE:
    case A.UPLOAD_ID_FILE_FAILURE:
    case A.CHECK_AGENT_ID_FAILURE:
      const {errorMessage} = payload;
      return {...state, loading: false, error: true, errorMessage};

    case A.SET_STEP:
      const {step} = payload;
      return {...state, nextStep: step};

    default:
      return state;
  }
}
